import api from '@/services/api'

export const hireGoals = async form => {
    try {
        return await api.post('/goals/hire', form)
    } catch (e) {
        console.log(e)
    }
}
